module.exports = __webpack_public_path__ + "../images/bar_stacked_chart.svg";